import * as Yup from 'yup';

import { StoreSchema } from './store';

const OnboardingOverviewStoreSchema = Yup.object().shape({
  store: StoreSchema.required(),
  owner_email: Yup.string().defined(),
  last_event_at: Yup.date().optional(),
  last_event_type: Yup.string().optional(),
});

export type OnboardingOverviewStore = Yup.InferType<typeof OnboardingOverviewStoreSchema>;

export const OnboardingOverviewSchema = Yup.object().shape({
  stores: Yup.array().of(OnboardingOverviewStoreSchema.required()).required(),
});

export type OnboardingOverview = Yup.InferType<typeof OnboardingOverviewSchema>;
